/* @flow */

export const COMPLETE_ONBOARDING_OPTIMISTICALLY =
  'COMPLETE_ONBOARDING_OPTIMISTICALLY';
